export default function useTimeout(tiempo = 500) {
    let timeout = null

    const resetNormal = (callback) => {
        clearTimeout(timeout)
        timeout = setTimeout(callback, tiempo)
    }
    
    const reset = (callback) => {
        clearTimeout(timeout)
        return new Promise(r => {
            timeout = setTimeout(() => {
                callback()
                r(true)
            }, tiempo)
        }) 
    }

    return {
        reset
    }
}